import React from "react";
import EvalResponses from "./EvalResponses";

const RATING_OPTIONS = [
  'Strongly Agree',
  'Agree',
  'Disagree',
  'Neutral',
];

export default function EvalProjectPartnerResponses(props) {
  return (
    <EvalResponses
      {...props}
      table="evaluationProjectPartner"
      ratingOptions={RATING_OPTIONS}
    />
  );
}
